import './Settings.sass';

import React from 'react';
import { Col, Row } from 'react-bootstrap';
import Button from 'react-bootstrap-button-loader';
import { Field } from 'redux-form';

import { Textarea } from '../../../commonComponents/Input/Input';
import WYSIWYG from '../../../commonComponents/WYSIWYG/WYSIWYG';

class SettingRow extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      errors: {},
      value: this.props.setting.value,
    };
  }

  validate = (fields, callback) => {
    const errors = {};
    const key = this.props.setting.key;
    const isWYSIWYG =
      (key.includes('EMAIL_') || key.includes('RATE_MESSAGE')) &&
      !key.includes('_SUBJECT');

    if (isWYSIWYG) {
      if (this.state.isUpdated && !this.state.value)
        errors[key] = 'Field is required';
    } else {
      if (!fields[key]) errors[key] = 'Field is required';
    }

    this.setState({ errors });
    if (errors[key]) return;
    const newKey = {
      id: this.props.setting.id,
      value: isWYSIWYG ? this.state.value : fields[key],
    };
    callback(newKey);
  };

  onChangeEditor = (value) => {
    this.setState({ value, isUpdated: true });
  };

  renderFieldOrWYSIWYG = () => {
    const { disabled = false, showWarning } = this.props;
    const { key, value } = this.props.setting;
    const isWYSIWYG =
      (key.includes('EMAIL_') || key.includes('RATE_MESSAGE')) &&
      !key.includes('_SUBJECT');

    if (isWYSIWYG) {
      return (
        <WYSIWYG
          onChange={this.onChangeEditor}
          value={this.state.value}
          disabled={disabled}
          updateEditorView={false}
          showWarning={showWarning}
        />
      );
    }
    if (key === 'MASTER_USER_REPORT_CSV_PATH') {
      return (
        <Field
          name={key}
          type="text"
          placeholder=""
          component={Textarea}
          disabled
          defaultValue={value}
        />
      );
    }
    return (
      <Field
        name={key}
        type="text"
        placeholder=""
        component={Textarea}
        disabled={disabled}
        defaultValue={value}
      />
    );
  };

  render() {
    const { disabled = false, handleSubmit, updateKey } = this.props;
    const key = this.props.setting.key;
    return (
      <form
        className="settingRowContainer"
        onSubmit={handleSubmit((fields) => this.validate(fields, updateKey))}
      >
        <Row>
          <Col xs={4} md={4}>
            <div className="key">{key}</div>
          </Col>
          <Col xs={4} md={4}>
            {this.renderFieldOrWYSIWYG()}
            {this.state.errors?.[key] && (
              <span className="errors">{this.state.errors[key]}</span>
            )}
          </Col>
          <Col xs={4} md={4}>
            {!(key === 'MASTER_USER_REPORT_CSV_PATH') && (
              <Button
                className="btn btn-success"
                type="submit"
                disabled={disabled}
              >
                Save
              </Button>
            )}
          </Col>
        </Row>
      </form>
    );
  }
}

export default SettingRow;
